import { CircularProgress } from '@ui/CircularProgress'
import CaloriesImage from '@images/CaloriesImage.svg'
import ClockImage from '@images/ClockImage.svg'
import { Heading } from '@ui/Heading'
import { Inline } from '@shared/layout/Inline'
import { CSSProperties, FC } from 'react'
import { CircularContainer, CircularDescription } from './styles'
import { formatTime } from '@shared/helpers/timeFormatting'

interface CircularsListProps {
	caloriesBurned: number
	time: number
	completedExercises: number
	overallExercises: number
	style?: CSSProperties
}

export const CircularsList: FC<CircularsListProps> = ({
	caloriesBurned,
	time,
	overallExercises,
	completedExercises,
	style,
}) => {
	return (
		<Inline justify={'center'} gap={15} style={style}>
			<CircularContainer>
				<CircularProgress
					circularProgressOptions={{
						percentage: 50,
						color: '#9F57FF8C',
						backgroundColor: '#DBC1FE8C',
						radius: 48,
						stroke: 8,
					}}>
					<img src={CaloriesImage} />
				</CircularProgress>
				<CircularDescription>
					{caloriesBurned}
					<br />
					Калорий
				</CircularDescription>
			</CircularContainer>
			<CircularContainer>
				<CircularProgress
					circularProgressOptions={{
						percentage: 65,
						color: '#FF4BD98C',
						backgroundColor: '#FEC1F18C',
						radius: 48,
						stroke: 8,
					}}>
					<img src={ClockImage} />
				</CircularProgress>
				<CircularDescription>
					{formatTime(time)}
					<br />
					время
				</CircularDescription>
			</CircularContainer>
			<CircularContainer>
				<CircularProgress
					circularProgressOptions={{
						percentage: (completedExercises / overallExercises) * 100,
						color: '#B7DC52',
						backgroundColor: '#e2fc8a',
						radius: 48,
						stroke: 8,
					}}>
					<Heading size={35} weight={900} color={'#B7DC52'}>
						{completedExercises}
					</Heading>
				</CircularProgress>
				<CircularDescription>
					упражнений
					<br />
					из {overallExercises}
				</CircularDescription>
			</CircularContainer>
		</Inline>
	)
}
